export default class LazyLoad {
  constructor() {
    this.loadEls = this.loadEls.bind(this)
    this.loadBgEls = this.loadBgEls.bind(this)

    this.viewport = {
      width: window.innerWidth
    }

    this.screenSize = this.viewport.width > 768
      ? "desktop"
      : "mobile"

    const lazyEls = Array.from(document.querySelectorAll(`[data-img-${this.screenSize}]`))
    const lazyBgEls = Array.from(document.querySelectorAll(`[data-bg-${this.screenSize}]`))
    const lazyVideoEls = Array.from(document.querySelectorAll(`[data-video-src]`))

    lazyEls.forEach(this.loadEls)
    lazyBgEls.forEach(this.loadBgEls)
    lazyVideoEls.forEach(this.loadVideoEls)
  }

  loadEls(el) {
    el.classList.remove("lazy-image")
    const src = el.getAttribute(`data-img-${this.screenSize}`)
    el.src = src
  }

  loadBgEls(el) {
    el.classList.remove("lazy-image")
    const src = el.getAttribute(`data-bg-${this.screenSize}`)
    el.style.backgroundImage = `url(${src})`
  }

  loadVideoEls(el) {
    const src = el.getAttribute(`data-video-src`)
    el.src = src
    el.play()
  }
}